export default __webpack_public_path__ + "static/media/escape-the-web.6ae9cf56.png";